import { Link, useLocation } from 'react-router-dom';

const isCardPath = (pathname: string): boolean =>
  /^\/decks\/[^/]+\/cards\/[^/]+\/?$/.test(pathname);

export const CardPageBackLink = () => {
  const location = useLocation();

  if (!isCardPath(location.pathname)) {
    return null;
  }

  const referrer = document.referrer;
  const hasSameHostReferrer =
    referrer.length > 0 && new URL(referrer).hostname === window.location.hostname;

  if (!hasSameHostReferrer) {
    return (
      <Link to="/" className="text-sm text-text-secondary hover:text-text">
        Go Home
      </Link>
    );
  }

  return (
    <button
      onClick={() => window.history.back()}
      className="w-fit text-sm text-text-secondary hover:text-text"
    >
      ← Go Back
    </button>
  );
};
